export function common() {
  
  //////ページトップ
  $(function () {
    var topBtn = $('#page-top');
    topBtn.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 650) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
    topBtn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 1000);
      return false;
    });
  });
  //////スムーススクロール
  $(function () {
    $('a[href^="#"]').click(function () {
      var speed = 1500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });
  });

  // $(document).ready(function() {
  //   $('.list_item').each(function() {
  //     // data-functionの値を配列化
  //     let functions = $(this).data('function');
  //     if (typeof functions === 'string') {
  //       // 文字列の場合はJSON.parse
  //       functions = JSON.parse(functions);
  //     }
  
  //     // 各spanの判定
  //     $(this).find('.list_item_function span').each(function() {
  //       const text = $(this).text().trim();
  //       if (functions.includes(text)) {
  //         $(this).addClass('f_active');
  //       } else {
  //         $(this).removeClass('f_active');
  //       }
  //     });
  //   });
  // });

  //ロード時に　data-functionに一致を確認してf_activeを付与
  $(document).ready(function() {
    $('.list_item').each(function() {
      let functions = $(this).data('function');
  
      // 型判定で分岐する
      if (Array.isArray(functions)) {
        // 配列の場合はそのまま利用
      } else if (typeof functions === 'string') {
        // JSON形式ならパース、そうでなければ単項目として扱う
        try {
          let parsed = JSON.parse(functions);
          functions = Array.isArray(parsed) ? parsed : [parsed];
        } catch (e) {
          // JSONでない場合は単一値として配列化
          functions = [functions];
        }
      } else if (functions !== undefined && functions !== null) {
        // undefined/null以外なら一応配列化
        functions = [functions];
      } else {
        functions = [];
      }
  
      // 各spanへのクラス付与・削除
      $(this).find('.list_item_function span').each(function() {
        const text = $(this).text().trim();
        if (functions.includes(text)) {
          $(this).addClass('f_active');
        } else {
          $(this).removeClass('f_active');
        }
      });
    });
  });

  //////checkbox
  var searchBox = '.search_item'; // 絞り込む項目を選択するエリア
  var listItem = '.list_item'; // 絞り込み対象のアイテム
  var hideClass = 'is_hide'; // 絞り込み対象外の場合に付与されるclass名
  $(function () {
    $(document).on('change', searchBox + ' input', function () {
      search_filter();
    });
  });

  function search_filter() {
    $(listItem).removeClass(hideClass);
    for (var i = 0; i < $(searchBox).length; i++) {
      var name = $(searchBox).eq(i).find('input').attr('name');
      var searchData = get_selected_input_items(name);
      if(searchData.length === 0 || searchData[0] === '') {
        continue;
      }
      for (var j = 0; j < $(listItem).length; j++) {
        var itemData = get_setting_values_in_item($(listItem).eq(j), name);
        var check = array_match_check(itemData, searchData);
        if(!check) {
          $(listItem).eq(j).addClass(hideClass);
        }
      }
    }
  }
  function get_selected_input_items(name) {
    var searchData = [];
    $('[name=' + name + ']:checked').each(function() {
      searchData.push($(this).val());
    });
    return searchData;
  }
  function get_setting_values_in_item(target, data) {
    var itemData = target.data(data);
    if(!Array.isArray(itemData)) {
      itemData = [itemData];
    }
    return itemData;
  }
  function array_match_check(arr1, arr2) {
    var arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
      if(arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
      }
    }
    return arrCheck;
  }
  //エリアで検索
  $(function(){
    $('.search_area .search_item_rt input[type="checkbox"]').change(function(){
      var cnt1 = $('.search_area .search_item_rt input[type="checkbox"]:checked').length;
          if(cnt1 == 0) {
            $("#check01").prop('checked',true);
          } else {
            $("#check01").prop('checked',false);
          }
      });
    $("#check01").change(function() {
      if ($("#check01").prop('checked')) {
        $('.search_area .search_item_rt input[type="checkbox"]').prop('checked', false);
      } else {
        $('.search_area .search_item_lt input[type="checkbox"]').prop('checked', true);
      }
    });
  });
  //機能で検索
  $(function(){
    $('.search_function .search_item_rt input[type="checkbox"]').change(function(){
      var cnt1 = $('.search_function .search_item_rt input[type="checkbox"]:checked').length;
          if(cnt1 == 0) {
            $("#check10").prop('checked',true);
          } else {
            $("#check10").prop('checked',false);
          }
      });
    $("#check10").change(function() {
      if ($("#check10").prop('checked')) {
        $('.search_function .search_item_rt input[type="checkbox"]').prop('checked', false);
      } else {
        $('.search_function .search_item_lt input[type="checkbox"]').prop('checked', true);
      }
    });
  });
  //////サイドバナー
  $(function () {
    var sideBtn = $('.search_item_btn');
    sideBtn.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        sideBtn.fadeIn();
      } else {
        sideBtn.fadeOut();
      }
    });
  });
  //////modal
  $(function() {
    var scrollPos;
    $('.btn').click(function() {
      scrollPos = $(window).scrollTop();
      $('.search_item_content').fadeIn();
      $(".search_item_modal").toggleClass('link_active');
      $('body').addClass('fixed').css({ top: -scrollPos });
      return false;
    });
    $('.search_item_overlay, .link_btn_close').click(function() {
      $('.search_item_content').fadeOut();
      $(".search_item_modal").removeClass('link_active');
      $('body').removeClass('fixed').css({ top: 0 });
      $(window).scrollTop(scrollPos);
      return false;
    });
  });


  //////もっと見る
  // $(function() {
  //   $(".list_item_more").click(function() {
  //     var show_text = $(this)
  //       .parent(".list_item_inner")
  //       .find(".list_item_hide");
  //     var small_height = 460; //This is initial height.
  //     var original_height = show_text.css({ height: "auto" }).height();

  //     if (show_text.hasClass("open")) {
  //       show_text.height(original_height).animate({ height: small_height }, 300);
  //       show_text.removeClass("open");
  //       $(this)
  //         .text("もっと見る")
  //         .removeClass("active");
  //     } else {
  //       show_text
  //         .height(small_height)
  //         .animate({ height: original_height }, 300, function() {
  //           show_text.height("auto");
  //         });
  //       show_text.addClass("open");
  //       $(this)
  //         .text("閉じる")
  //         .addClass("active");
  //     }
  //   });
  // });


  //-------------------------
  //
  //もっと見る　改定
  //
  //------------------------
  
  // 個別に高さ取得する関数（.list_item_hideを引数に）
  function getLimitedHeight($hideElem) {
    var $col = $hideElem.find('.list_item_col');
    var $img = $hideElem.find('.list_item_img');
    var $txt = $hideElem.find('.list_item_txt');

    var lineHeight = parseFloat($txt.css('line-height'));
    var twoLineHeight = lineHeight * 2;

    var totalHeight = $col.outerHeight() + $img.outerHeight() + twoLineHeight;
    return totalHeight;
  }

  // すべての.list_itemごとに初期高さをセット
  function setLimitedHeights() {
    $('.list_item').each(function() {
      var $item = $(this);
      var $hideElem = $item.find('.list_item_hide');
      if (!$hideElem.hasClass('open')) {
        var limitedHeight = getLimitedHeight($hideElem);
        $hideElem.css({
          height: limitedHeight + 'px',
          overflow: 'hidden'
        });
      }
    });
  }

  // 各.list_itemの「もっと見る」ボタンクリック処理
  $(function() {
    // もっと見るクリックをイベント委譲で確実にキャッチ
    $(document).on('click', '.list_item_more', function() {
      var $moreBtn = $(this);
      var $listItem = $moreBtn.closest('.list_item');
      var $hideElem = $listItem.find('.list_item_hide');
  
      if ($hideElem.hasClass('open')) {
        console.log('閉じる動作を開始');
        var limitedHeight = getLimitedHeight($hideElem);
        $hideElem.animate({height: limitedHeight}, 300, function() {
          $hideElem.removeClass('open');
          $moreBtn.removeClass('active').text('もっと見る');
        });
      } else {
        console.log('もっと見る動作を開始');
        var autoHeight = $hideElem.css('height', 'auto').outerHeight();
        $hideElem.height(getLimitedHeight($hideElem))
          .animate({height: autoHeight}, 300, function() {
            $hideElem.css('height', 'auto').addClass('open');
            $moreBtn.addClass('active').text('閉じる');
          });
      }
    });
  });

  // 画像なども含む全ロード後＋リサイズ時に高さを設定
  $(window).on('load resize', setLimitedHeights);



}